import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Alert, Badge } from 'react-bootstrap';
import axios from 'axios';

function Blacklist({ user }) {
  const [blacklist, setBlacklist] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {
    fetchBlacklist();
  }, []);

  const fetchBlacklist = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/blacklist', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBlacklist(response.data.blacklist || []);
    } catch (error) {
      console.error('Error fetching blacklist:', error);
    }
  };

  const handleMoveToWhitelist = async (phoneNumber) => {
    if (!window.confirm('Move this number to whitelist? They will be able to call without authentication.')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/blacklist/move-to-whitelist', 
        { phoneNumber, name: 'Moved from blacklist' },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      setMessage('Number moved to whitelist successfully!');
      setMessageType('success');
      fetchBlacklist();
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to move number');
      setMessageType('danger');
    }
  };

  const handleRemove = async (phoneNumber) => {
    if (!window.confirm('Remove this number from blacklist?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`/api/blacklist/${phoneNumber}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Number removed from blacklist');
      setMessageType('info');
      fetchBlacklist();
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Failed to remove number');
      setMessageType('danger');
    }
  };

  return (
    <Container className="mainWrapper">
      <Row className="mb-4">
        <Col>
          <h2 className="text-light fs-5">
            <i className="fas fa-ban me-2 text-danger"></i>
            Blocked Numbers
          </h2>
        </Col>
      </Row>

      {message && (
        <Row className="mb-3">
          <Col>
            <Alert variant={messageType}>{message}</Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <p className="text-muted mb-3">
                <i className="fas fa-info-circle me-2"></i>
                Numbers are automatically blocked after 3 failed authentication attempts.
              </p>

              {blacklist.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-shield-alt fa-4x text-muted mb-3"></i>
                  <p className="text-muted">No blocked numbers</p>
                  <p className="text-muted small">
                    Numbers will appear here after failed authentication attempts
                  </p>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Phone Number</th>
                      <th>Failed Attempts</th>
                      <th>Blocked On</th>
                      <th>Last Attempt</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {blacklist.map((blocked) => (
                      <tr key={blocked._id} className="blacklist-item">
                        <td>
                          <i className="fas fa-user-times text-danger me-2"></i>
                          <Badge bg="danger">{blocked.phoneNumber}</Badge>
                        </td>
                        <td>
                          <Badge bg="warning" text="dark">{blocked.failedAttempts}</Badge>
                        </td>
                        <td>{new Date(blocked.blockedAt).toLocaleDateString()}</td>
                        <td>{new Date(blocked.lastAttempt).toLocaleString()}</td>
                        <td>
                          <div className="btn-group" role="group">
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() => handleMoveToWhitelist(blocked.phoneNumber)}
                              title="Move to whitelist"
                            >
                              <i className="fas fa-check"></i>
                            </Button>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleRemove(blocked.phoneNumber)}
                              title="Remove from blacklist"
                            >
                              <i className="fas fa-trash"></i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Blacklist;
